import "./path";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./style/reset.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VueI18n from "vue-i18n";

import enLocale from "element-ui/lib/locale/lang/en";
// import zhCNLocale from "element-ui/lib/locale/lang/zh-CN";
import zhTWLocale from "element-ui/lib/locale/lang/zh-TW";

import "./permission";
import "./style/font.css";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "./styles/index.scss"; // global css

Vue.use(VueI18n);

// 多语言实例
const i18n = new VueI18n({
  locale: (function() {
    if (localStorage.getItem("lang")) {
      return localStorage.getItem("lang");
    }
    return "zh-TW";
  })(),
  messages: {
    en: Object.assign(require("./assets/i18n/en-US"), enLocale),
    // "zh-CN": Object.assign(require("./assets/i18n/zh-CN"), zhCNLocale),
    "zh-TW": Object.assign(require("./assets/i18n/zh-TW"), zhTWLocale),
  },
});

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });

import SvgIcon from "@/components/tools/SvgIcon"; // svg组件
import logComponent from "@/utils/globalLog.js";
// 注册全局组件
Vue.component("svg-icon", SvgIcon);
const requireAll = (reqireContext) => reqireContext.keys().map(reqireContext);
const req = require.context("./icons/svg", false, /\.svg$/);
requireAll(req);

Vue.config.productionTip = false;
Vue.prototype.logger = logComponent;

import { Calendar, List, Cell,Panel   } from "vant";
import "vant/lib/button/style";
Vue.use(Calendar);
Vue.use(List);
Vue.use(Cell);
Vue.use(Panel );
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
